/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Inline_Have_AccountInputs */

const en_auth_inline_have_account = /** @type {(inputs: Auth_Inline_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Already have an account? Sign in`)
};

const es_auth_inline_have_account = /** @type {(inputs: Auth_Inline_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Ya tienes cuenta? Inicia sesión`)
};

const de_auth_inline_have_account = /** @type {(inputs: Auth_Inline_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie haben bereits ein Konto? Anmelden`)
};

const zh_auth_inline_have_account = /** @type {(inputs: Auth_Inline_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已有账户？登录`)
};

const ar_auth_inline_have_account = /** @type {(inputs: Auth_Inline_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لديك حساب بالفعل؟ سجّل الدخول`)
};

const fr_auth_inline_have_account = /** @type {(inputs: Auth_Inline_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous avez déjà un compte ? Se connecter`)
};

const vi_auth_inline_have_account = /** @type {(inputs: Auth_Inline_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã có tài khoản? Đăng nhập`)
};

const sw_auth_inline_have_account = /** @type {(inputs: Auth_Inline_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je, tayari una akaunti? Ingia`)
};

const th_auth_inline_have_account = /** @type {(inputs: Auth_Inline_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`มีบัญชีอยู่แล้ว? เข้าสู่ระบบ`)
};

const bs_auth_inline_have_account = /** @type {(inputs: Auth_Inline_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Već imate račun? Prijavite se`)
};

const ja_auth_inline_have_account = /** @type {(inputs: Auth_Inline_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すでにアカウントをお持ちですか？サインイン`)
};

const ko_auth_inline_have_account = /** @type {(inputs: Auth_Inline_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이미 계정이 있으신가요? 로그인`)
};

const pt_auth_inline_have_account = /** @type {(inputs: Auth_Inline_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Já tem uma conta? Entre`)
};

const it_auth_inline_have_account = /** @type {(inputs: Auth_Inline_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hai già un account? Accedi`)
};

const sv_auth_inline_have_account = /** @type {(inputs: Auth_Inline_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Har du redan ett konto? Logga in`)
};

const nl_auth_inline_have_account = /** @type {(inputs: Auth_Inline_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heb je al een account? Inloggen`)
};

const da_auth_inline_have_account = /** @type {(inputs: Auth_Inline_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Har du allerede en konto? Log ind`)
};

const nb_auth_inline_have_account = /** @type {(inputs: Auth_Inline_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Har du allerede en konto? Logg inn`)
};

const fi_auth_inline_have_account = /** @type {(inputs: Auth_Inline_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onko sinulla jo tili? Kirjaudu sisään`)
};

const pl_auth_inline_have_account = /** @type {(inputs: Auth_Inline_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masz już konto? Zaloguj się`)
};

const ru_auth_inline_have_account = /** @type {(inputs: Auth_Inline_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уже есть аккаунт? Войти`)
};

const tr_auth_inline_have_account = /** @type {(inputs: Auth_Inline_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaten hesabınız var mı? Giriş yapın`)
};

const hi_auth_inline_have_account = /** @type {(inputs: Auth_Inline_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पहले से ही एक खाता है? साइन इन करें`)
};

const id_auth_inline_have_account = /** @type {(inputs: Auth_Inline_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sudah punya akun? Masuk`)
};

const ms_auth_inline_have_account = /** @type {(inputs: Auth_Inline_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sudah ada akaun? Log masuk`)
};

const cs_auth_inline_have_account = /** @type {(inputs: Auth_Inline_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Už máte účet? Přihlaste se`)
};

const el_auth_inline_have_account = /** @type {(inputs: Auth_Inline_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Έχετε ήδη λογαριασμό; Σύνδεση`)
};

const he_auth_inline_have_account = /** @type {(inputs: Auth_Inline_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`כבר יש לכם חשבון? התחברו`)
};

const af_auth_inline_have_account = /** @type {(inputs: Auth_Inline_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het jy reeds 'n rekening? Meld aan`)
};

const hu_auth_inline_have_account = /** @type {(inputs: Auth_Inline_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Már van fiókja? Jelentkezzen be`)
};

/**
* | output |
* | --- |
* | "Already have an account? Sign in" |
*
* @param {Auth_Inline_Have_AccountInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const auth_inline_have_account = /** @type {((inputs?: Auth_Inline_Have_AccountInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Inline_Have_AccountInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_auth_inline_have_account(inputs)
	if (locale === "de") return de_auth_inline_have_account(inputs)
	if (locale === "zh") return zh_auth_inline_have_account(inputs)
	if (locale === "ar") return ar_auth_inline_have_account(inputs)
	if (locale === "fr") return fr_auth_inline_have_account(inputs)
	if (locale === "vi") return vi_auth_inline_have_account(inputs)
	if (locale === "sw") return sw_auth_inline_have_account(inputs)
	if (locale === "th") return th_auth_inline_have_account(inputs)
	if (locale === "bs") return bs_auth_inline_have_account(inputs)
	if (locale === "ja") return ja_auth_inline_have_account(inputs)
	if (locale === "ko") return ko_auth_inline_have_account(inputs)
	if (locale === "pt") return pt_auth_inline_have_account(inputs)
	if (locale === "it") return it_auth_inline_have_account(inputs)
	if (locale === "sv") return sv_auth_inline_have_account(inputs)
	if (locale === "nl") return nl_auth_inline_have_account(inputs)
	if (locale === "da") return da_auth_inline_have_account(inputs)
	if (locale === "nb") return nb_auth_inline_have_account(inputs)
	if (locale === "fi") return fi_auth_inline_have_account(inputs)
	if (locale === "pl") return pl_auth_inline_have_account(inputs)
	if (locale === "ru") return ru_auth_inline_have_account(inputs)
	if (locale === "tr") return tr_auth_inline_have_account(inputs)
	if (locale === "hi") return hi_auth_inline_have_account(inputs)
	if (locale === "id") return id_auth_inline_have_account(inputs)
	if (locale === "ms") return ms_auth_inline_have_account(inputs)
	if (locale === "cs") return cs_auth_inline_have_account(inputs)
	if (locale === "el") return el_auth_inline_have_account(inputs)
	if (locale === "he") return he_auth_inline_have_account(inputs)
	if (locale === "af") return af_auth_inline_have_account(inputs)
	if (locale === "hu") return hu_auth_inline_have_account(inputs)
	return en_auth_inline_have_account(inputs)
});